<template>
    <div class="block-content quantity-select-prices" :class="{'desktop': desktop, 'all-screens': allScreens}">
        <div v-for="trayFormat in trayFormatsWithPrices" class="price">
            <div style="text-align: left">
                Bandeja {{ trayFormat.unidades }} alvéolos x{{ seedsByAlveolus }}<br>
                <span style="font-weight: normal;">Nº de bandejas {{ trayFormat.value }}</span>
            </div>
            <div>
                {{ formatMoney(trayFormat.totalPrice) }}
            </div>
        </div>
        <div class="total-price" :class="{'showing-trays': trayFormatsWithPrices.length > 0}">
            <div class="price">
                <div>Total <span style="font-weight: normal;">(Iva incluido)</span></div>
                <div>{{ formatMoney(totalPrice) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "QuantitySelectTotals",
        props: {
            trayFormatsWithPrices: {
                type: Array,
                default: () => []
            },
            totalPrice: {
                type: Number
            },
            minOrder: {
                type: Number
            },
            desktop: {
                type: Boolean,
                default: false
            },
            seedsByAlveolus: {
                type: Number,
                default: 1
            },
            allScreens: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {

            }
        }
    }
</script>

<style scoped>
    .quantity-select-prices {
        margin-top: 20px;
    }

    .quantity-select-prices .price {
        display: flex;
        justify-content: space-between;
        padding-bottom: 1rem;
        font-weight: bold;
    }

    .quantity-select-prices .total-price {
        padding-top: 1rem;
    }

    .quantity-select-prices .total-price.showing-trays {
        border-top: 1px solid #cbc8c8;
    }

    .quantity-select-prices.desktop:not(.all-screens) {
        display: none;
    }

    @media (min-width: 992px) {
        .quantity-select-prices:not(.all-screens),
        .quantity-select-prices:not(.all-screens):not(.desktop){
            display: none;
        }

        .quantity-select-prices.desktop:not(.all-screens) {
            display: block;
            padding: 20px;
        }
    }

</style>
